import { supabase } from "../supabase";

export const CAMPAIGN_SELECT = "*";
export const CAMPAIGN_TEMPLATE_SELECT = "*";
export const COUPON_SELECT = "*";
export const ANNOUNCEMENT_SELECT = "*";

const throwOnError = async (query) => {
  const result = await query;
  if (result.error) throw result.error;
  return result;
};

const throwOnInvokeError = async (invocation) => {
  const result = await invocation;
  if (result.error) throw Object.assign(result.error, { data: result.data });
  return result;
};

export const listCampaigns = () => throwOnError(
  supabase.from("campaigns").select(CAMPAIGN_SELECT).order("created_at", { ascending: false }),
);

export const createCampaign = (campaign) => throwOnError(
  supabase.from("campaigns").insert(campaign).select(CAMPAIGN_SELECT).single(),
);

export const updateCampaign = (id, updates) => throwOnError(
  supabase.from("campaigns").update(updates).eq("id", id),
);

export const deleteCampaign = (id) => throwOnError(
  supabase.from("campaigns").delete().eq("id", id),
);

export const listCampaignTemplates = () => throwOnError(
  supabase.from("campaign_templates").select(CAMPAIGN_TEMPLATE_SELECT).order("name"),
);

export const createCampaignTemplate = (template) => throwOnError(
  supabase.from("campaign_templates").insert(template).select(CAMPAIGN_TEMPLATE_SELECT).single(),
);

export const listActiveCoupons = () => throwOnError(
  supabase.from("coupons").select(COUPON_SELECT).eq("active", true).order("created_at", { ascending: false }),
);

export const listCoupons = () => throwOnError(
  supabase.from("coupons").select(COUPON_SELECT).order("created_at", { ascending: false }),
);

export const createCoupon = (coupon) => throwOnError(
  supabase.from("coupons").insert(coupon).select(COUPON_SELECT).single(),
);

export const updateCoupon = (id, updates) => throwOnError(
  supabase.from("coupons").update(updates).eq("id", id),
);

export const deleteCoupon = (id) => throwOnError(
  supabase.from("coupons").delete().eq("id", id),
);

export const listActiveAnnouncements = () => throwOnError(
  supabase.from("announcements").select(ANNOUNCEMENT_SELECT).eq("active", true)
    .order("published_at", { ascending: false }),
);

export const listAnnouncements = () => throwOnError(
  supabase.from("announcements").select(ANNOUNCEMENT_SELECT).order("published_at", { ascending: false }),
);

export const createAnnouncement = (announcement) => throwOnError(
  supabase.from("announcements").insert(announcement).select(ANNOUNCEMENT_SELECT).single(),
);

export const updateAnnouncement = (id, updates, selectUpdated = false) => throwOnError(
  selectUpdated
    ? supabase.from("announcements").update(updates).eq("id", id).select(ANNOUNCEMENT_SELECT).single()
    : supabase.from("announcements").update(updates).eq("id", id),
);

export const deleteAnnouncement = (id) => throwOnError(
  supabase.from("announcements").delete().eq("id", id),
);

export const sendCampaign = (body) => throwOnInvokeError(
  supabase.functions.invoke("send-campaign", { body }),
);

export const sendCampaignPreview = (body) => throwOnInvokeError(
  supabase.functions.invoke("send-campaign-preview", { body }),
);

export const sendAnnouncementNotification = (body) => throwOnInvokeError(
  supabase.functions.invoke("send-announcement-notification", { body }),
);
